const TIMER_WIDGET_PREFIX = "tw";

export const TIMER_WIDGET_TEST_IDS = {
    CONTAINER: `${TIMER_WIDGET_PREFIX}_container`,
    SVG: `${TIMER_WIDGET_PREFIX}_svg`,
    REMAINING_TIME: `${TIMER_WIDGET_PREFIX}_time`,
};
